<template>
  <div class="comment-container">
    <div class="comment-header" >
      <div class="comment-info" v-bind:class="($vuetify.theme.dark) ? 'textDark' : 'black--text'">
        <span class="comment-name" >{{ item.username }}</span>
        <span class="comment-date">{{ item.date }}</span>
        <v-chip v-if="item.cmType == 'H'" color="secondary" class="mx-2 py-2" rounded x-small label>
          <v-icon class="px-1" x-small>mdi-stop-circle-outline</v-icon>Hold Comments
        </v-chip>
        <v-chip v-if="item.cmType == 'C'" color="error" class="mx-2 py-2" rounded x-small label>
          <v-icon x-small class="px-1">mdi-cancel</v-icon>Cancel Comments
        </v-chip>
      </div>
    </div>
    <div class="comment-body pb-1">
      {{ item.comments }}
      <slot name="actions"></slot>
    </div>
    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  name: 'CommentItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.comment-container {
  margin-bottom: 10px;
  overflow-x: hidden;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 20px;
}

.comment-info {
  font-size: 15px;
  font-weight: bold;
}

.comment-name {
  margin-right: 10px;
}
</style>
